import { Link } from "react-router";
import { AvisoDeSucessoDaChegada } from "../componentes/avisos/AvisoDeSucessoDaChegada";
import { GradeDoPainel } from "../componentes/paineis/GradeDoPainel";
import { usePainelInicial } from "../nucleo/paineis";
import type { PainelParaVer } from "../nucleo/paineis";
import { useTitulo } from "../nucleo/titulo";
import { ConsoleAdmin } from "./ConsoleAdmin";

/**
 * A tela inicial do console: o painel que o papel da pessoa recebe e, sem ele, o console de
 * sempre. Falha ao buscar o painel também cai no console — a porta de entrada nunca fica
 * dependendo de um painel.
 */
export function InicioDoConsole() {
  const inicial = usePainelInicial();

  const painel = inicial.data?.painel;
  return (
    <>
      <AvisoDeSucessoDaChegada />
      {inicial.isPending ? (
        <p role="status">Carregando…</p>
      ) : painel ? (
        <PainelInicial painel={painel} />
      ) : (
        <ConsoleAdmin />
      )}
    </>
  );
}

function PainelInicial({ painel }: { painel: PainelParaVer }) {
  useTitulo(painel.nome);
  return (
    <>
      <h1 className="titulo-pagina">{painel.nome}</h1>
      {painel.descricao ? <p className="lead">{painel.descricao}</p> : null}
      <GradeDoPainel painel={painel} />
      <p className="nota-rodape">
        <Link to="/admin/visao-geral">Ver o console completo</Link>
      </p>
    </>
  );
}
